export const reactSelectStyles = {
  control: (base: any) => ({
    ...base,
    background: '#222',
    borderColor: '#FFD600',
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (base: any) => ({
    ...base,
    height: '38px',
    paddingTop: 0,
    paddingBottom: 0,
    display: 'flex',
    alignItems: 'center',
  }),
  singleValue: (base: any) => ({
    ...base,
    color: '#FFD600',
    margin: 0,
    lineHeight: '1.2',
  }),
  input: (base: any) => ({
    ...base,
    color: '#FFD600',
    margin: 0,
    padding: 0,
  }),
  placeholder: (base: any) => ({
    ...base,
    color: '#888',
    margin: 0,
  }),
  option: (base: any, state: any) => ({
    ...base,
    background: state.isFocused ? '#FFD600' : '#111',
    color: state.isFocused ? '#111' : '#FFD600',
    padding: '4px 8px',
  }),
  multiValue: (base: any) => ({
    ...base,
    background: '#FFD600',
    color: '#111',
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    color: '#111',
  }),
};
